import React, {useEffect, useRef, useState} from 'react';
import PropTypes from 'prop-types';

import {IconoirCustomMoreVerticalAlt} from '@ey-xd/motif-icon';

import {labels} from '../../../../../../../util/utils';

import Dropdown from '../../../../../../CoreWrappers/Dropdown';
import Button from '../../../../../../CoreWrappers/Button';

import DuplicateMessage from '../../DuplicateMessage';

const Options = ({id, ...rest}) => {
	const [open, setOpen] = useState(false);
	const [duplicateMessageOpen, setDuplicateMessageOpen] = useState(false);

	const element = useRef(null);

	useEffect(() => {
		const scrollbar = element?.current?.closest('.customScrollbar');

		const hideOnScroll = () => setOpen(false);

		if (scrollbar) scrollbar.addEventListener('scroll', hideOnScroll);
		return () => {
			scrollbar?.removeEventListener('scroll', hideOnScroll);
		};
	}, []);

	const renderTrigger = () => {
		const props = {
			svg: IconoirCustomMoreVerticalAlt,
			variant: 'ghost'
		};

		return <Button {...props} />;
	};

	const items = [
		{
			id: 1,
			label: labels.duplicateMessage,
			onClick: (e) => {
				e.stopPropagation();
				setDuplicateMessageOpen(true);
				setOpen(false);
			}
		}
	];

	const props = {
		id: `${id}`,
		placement: 'bottom-right',
		trigger: renderTrigger(),
		items,
		stableScroll: false,
		topfix: true,
		reversed: true
	};

	const dmProps = {
		showModal: duplicateMessageOpen,
		setShowModal: setDuplicateMessageOpen,
		...rest
	};

	return (
		<>
			<Dropdown {...props} />
			{duplicateMessageOpen && <DuplicateMessage {...dmProps} />}
		</>
	);
};

export default Options;
